import { render, staticRenderFns } from "./StoreWidgetForm.vue?vue&type=template&id=10d9fc64&scoped=true"
import script from "./StoreWidgetForm.vue?vue&type=script&lang=js"
export * from "./StoreWidgetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9fc64",
  null
  
)

export default component.exports